import React, { useRef, useState } from 'react';
import cc from 'classcat';

interface IAccordion {
    children: React.ReactNode;
    noBorder?: boolean;
    headerElement: React.ReactNode;
}

export const Accordion = ({ children, noBorder, headerElement }: IAccordion) => {
    const [collapse, setCollapse] = useState(true);
    const contentRef = useRef<HTMLDivElement>(null);
    let maxHeight = 0;

    if (contentRef.current) {
        const children = Array.from(contentRef.current.children);

        children.forEach(child => {
            const childHeight = child.getBoundingClientRect().height;
            const style = window.getComputedStyle(child);
            maxHeight += childHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
        });
    }

    return (
        <div className="accordion">
            <div className={cc(['accordion__main', { 'accordion__main--no-border': noBorder }])} onClick={() => setCollapse(prev => !prev)}>
                {headerElement}
                <img src="/img/header2/arrow-down.svg" alt="arrow down" className={cc({ 'accordion__arrow--rotate': !collapse })} />
            </div>
            <div ref={contentRef} className="accordion__content" style={{ maxHeight: collapse ? 0 : maxHeight }}>
                {children}
            </div>
        </div>
    );
};
